export default __webpack_public_path__ + "static/outsourcing-o-sviluppo-in-house-quale scegliere-bc2bda560d50bf000719b435aad71259.jpg";